<p [innerHtml]="text()" style="display: inline"></p>
@if (!isLast()) {
  @if (!mobileMode()) {
    <span style="white-space: nowrap">
      {{ lastWord()
      }}<input
        class="input"
        [(ngModel)]="currentValue"
        (input)="onInputChange()"
        (focus)="focusInput()"
        (blur)="onBlur()"
        #answer="ngModel"
    /></span>
  } @else {
    <!-- Mobile input doesn't trigger soft keyboard -->
    <span style="white-space: nowrap; line-height: 1rem">
      {{ lastWord() }}
      <!--eslint-disable-next-line-->
      <span
        [tabIndex]="0"
        class="input-mobile"
        [ngClass]="{ 'active-input': isActiveInput(), 'input-empty': !currentValue }"
        (keyup.enter)="focusInput()"
        (click)="focusInput()">
        <onset-cloze-test-exercise-input-field
          [inputText]="currentValue"
          [inputNumber]="nr()"
          [answer]="currentAnswer()">
        </onset-cloze-test-exercise-input-field>
      </span>
    </span>
  }
}
